import { BrandMark } from "@/features/site/components/brand-mark";
import { cn } from "@/lib/utils";

/**
 * A post's picture, sized before it loads so the page never jumps. A post without one gets a
 * quiet tile in the site's wash with the brand mark, so a grid of cards still reads as a set.
 */
export const BlogCover = ({
  src,
  alt,
  width,
  height,
  priority,
  className,
}: {
  src: string | null;
  alt: string;
  width: number | null;
  height: number | null;
  /** The first picture on the page: loaded at once instead of lazily. */
  priority?: boolean;
  className?: string;
}) => {
  if (!src) {
    return (
      <div
        aria-hidden
        className={cn(
          "relative grid place-items-center overflow-hidden bg-linear-to-br from-[var(--site-wash)] via-[var(--site-tint)] to-[var(--site-fog)]",
          className,
        )}
      >
        <span className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,var(--site-glow),transparent_60%)]" />
        <BrandMark className="relative size-12 rounded-2xl opacity-90 shadow-[0_12px_32px_var(--site-glow)] [&_svg]:h-7" />
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={alt}
      width={width ?? undefined}
      height={height ?? undefined}
      loading={priority ? "eager" : "lazy"}
      decoding={priority ? "sync" : "async"}
      // React 19 passes `fetchPriority` through as the attribute.
      fetchPriority={priority ? "high" : "auto"}
      className={cn("bg-muted object-cover", className)}
    />
  );
};
